import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import CountAdjSync01Actions, { CountAdjSync01Types } from '../Stores/CountAdjSync01/Actions';

const getAppStore = state => state.app;

export function* countAdjSync01FetchCountAdjSync01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(CountAdjSync01Actions.countAdjSync01FetchCountAdjSync01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `countAdj/indexProcess/COUNT_ADJ_SYNC_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        CountAdjSync01Actions.countAdjSync01FetchCountAdjSync01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjSync01Actions.countAdjSync01FetchCountAdjSync01Loading(false));
  }
}

export function* countAdjSync01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/countAdjDetail/update/${hdrId}`));
}

export function* countAdjSync01SyncNow({ hdrIds }) {
  try {
    yield put(CountAdjSync01Actions.countAdjSync01SyncLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `countAdj/syncProcess/COUNT_ADJ_SYNC_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(CountAdjSync01Actions.countAdjSync01SyncNowSuccess());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjSync01Actions.countAdjSync01SyncLoading(false));
  }
}

export const saga = [
  takeLatest(CountAdjSync01Types.COUNT_ADJ_SYNC01_GO_TO_DOCUMENT, countAdjSync01GoToDocument),
  takeLatest(
    CountAdjSync01Types.COUNT_ADJ_SYNC01_FETCH_COUNT_ADJ_SYNC01,
    countAdjSync01FetchCountAdjSync01
  ),
  takeLatest(CountAdjSync01Types.COUNT_ADJ_SYNC01_SYNC_NOW, countAdjSync01SyncNow)
];
